import { Container, theme } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type Employee from 'modules/employees/store/models/Employee'
import type PlanningVersion from 'modules/time_planning/store/models/PlanningVersion'

import Content from './Content'
import Navigator from './Navigator'

export interface Props {
  planningVersion: PlanningVersion
  employee: Employee
  canAssignEmployees: boolean
  canManageCompanySchedules: boolean
}

const IdReal = observer(
  ({ planningVersion, employee, canAssignEmployees, canManageCompanySchedules }: Props) => {
    return (
      <>
        <div
          style={{
            marginBottom: theme.dimensions.bodyPadding,
          }}
        >
          <Navigator employee={employee} planningVersion={planningVersion} />
        </div>
        <Container fullWidth>
          <Content
            employee={employee}
            planningVersion={planningVersion}
            canAssignEmployees={canAssignEmployees}
            canManageCompanySchedules={canManageCompanySchedules}
          />
        </Container>
      </>
    )
  }
)

const Id = (props: Props) => <IdReal {...props} />

export default Id
